// export const url = "http://localhost:3033/api";
export const url = "https://erp.mgreeninnovations.com/api";
// export const url = "https://erp-api.zsmaterials.in/api";
// export const url = "http://localhost:3033/api";
export const IMAGE_URL =
  "https://erp.mgreeninnovations.com/api/image/upload-image";
// export const IMAGE_BASE_URL = "http://localhost:3033/api/image/get-image";
export const IMAGE_BASE_URL =
  "https://erp.mgreeninnovations.com/api/image/get-image";
